var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vk-modal-header',{staticClass:"bg-white c-black text-bold MODAL-HEADER"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }